import { useEffect, useState } from "react";
import "./modules.css";
import { globalVariables } from "helper/globalVariables";
import { Upload, avatar } from "helper/images";
import { file, trash } from "helper/icons";
import { useUploadImage } from "redux/hooks";
import Loader from "../loader";

export const FileUpload = (props) => {
  const {
    checkValidation,
    width = "w-[358px] lg:w-[384px] max-[380px]:w-[100%]",
    icon = avatar,
    onSetImage,
    defaultImage = "",
    label = "",
    isFileUpload = false,
    onRemoveFile,
    disabled = false,
    containerWidth = "max-[400px]:w-[100%]",
    setFileLoading,
    onSetFileData,
    defaultFileName = "",
    defaultFileSize = "",
    fileUploadDesc = globalVariables.csvOrPdf,
    fileType = ["text/csv", "application/pdf"],
    fileTypeString = ".csv, .pdf",
    uploadId = "upload",
  } = props || {};

  const [image, setImage] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  const imageType = ["image/png", "image/jpg", "image/jpeg"];
  const { onUploadImage, imageUrl } = useUploadImage();

  useEffect(() => {
    if (defaultImage) setImage(defaultImage);
  }, [defaultImage]);

  useEffect(() => {
    if (defaultFileName) setFileName(defaultFileName);
  }, [defaultFileName]);

  useEffect(() => {
    if (defaultFileSize) setFileSize(defaultFileSize);
  }, [defaultFileSize]);

  useEffect(() => {
    if (imageUrl) {
      onSetImage?.(imageUrl);
      setLoading(false);
      setFileLoading?.(false);
    }
  }, [imageUrl]);

  const handleFileChange = async (e) => {
    const files = e.target?.files || e.dataTransfer?.files;
    if (!files?.length) return;

    const file = files[0];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (file.size > maxSize) {
      setError(globalVariables.maximumFileSizeAllowed);
      return;
    }

    const type = file?.type;

    if (isFileUpload ? fileType.includes(type) : imageType.includes(type)) {
      const img = URL.createObjectURL(file);
      if (isFileUpload) {
        setLoading(true);
        setFileLoading?.(true);
        try {
          onUploadImage(file);
        } catch (err) {
          setLoading(false);
          setFileLoading?.(false);
        }
      } else {
        setLoading(false);
        onSetImage?.(file);
      }

      setImage(img);
      setError("");
      setFileName(file.name);
      setFileSize(parseInt(file.size / 1000));
      onSetFileData?.(file.name, parseInt(file.size / 1000));
    } else {
      setImage("");
      onSetImage?.("");
      setFileName("");
      setFileSize("");
      onSetFileData?.("", "");
      setError(
        isFileUpload
          ? globalVariables.uploadedFileNotValid
          : globalVariables.uploadedImageNotValid
      );
    }
  };

  const removeFile = () => {
    setImage("");
    onSetImage?.("");
    onRemoveFile?.();
    setFileName("");
    setFileSize("");
  };

  return (
    <div className="flex flex-col items-center">
      <div className={`flex flex-col items-center ${containerWidth}`}>
        {!!label && (
          <div className="self-start">
            <span className="text-gray-700 font-medium text-sm">{label}</span>
            <div className="mt-2" />
          </div>
        )}

        {!isFileUpload &&
          (image ? (
            <img
              className="shadow-100 rounded-full mt-[4px] lg:mt-[5px] h-16 w-16 object-cover"
              src={image}
              alt=""
            />
          ) : (
            <img
              className="mt-[4px] lg:mt-[5px] rounded-full shadow-100  h-16 w-16"
              src={icon}
              alt=""
              height={64}
              width={64}
            />
          ))}

        {!isFileUpload && !disabled && <div className="mt-5" />}

        {!disabled && (
          <input
            type="file"
            id={uploadId}
            accept={
              isFileUpload ? fileTypeString : "image/png, image/jpg, image/jpeg"
            }
            onChange={handleFileChange}
            onClick={(event) => {
              event.target.value = null;
            }}
            className="absolute w-96 h-32 bg-primary"
            hidden
            size="50000"
            disabled={disabled}
          />
        )}

        {!disabled && (
          <label htmlFor={uploadId}>
            <div
              className={`bg-white ${
                disabled && "opacity-50"
              } ${!disabled && "uploadStyle"} rounded-xl border border-solid ${width} ${
                checkValidation || error
                  ? image
                    ? "border-gray-300"
                    : "border-red"
                  : "border-gray-300"
              } ${isDragging ? "ring-2 ring-primary bg-gray-50" : ""}`}
              style={{ width }}
              onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                if (!disabled) handleFileChange(e);
              }}
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={() => setIsDragging(true)}
              onDragLeave={() => setIsDragging(false)}
            >
              <div className="py-4 flex flex-col items-center px-6 cursor-pointer">
                {isFileUpload && loading ? (
                  <Loader stroke="text-gradient-500" />
                ) : (
                  <Upload />
                )}
                <div className="mt-3" />
                <div className="flex flex-col mb-1">
                  <span className="text-sm font-semibold text-center text-primary">
                    {globalVariables.clickToUpload}
                  </span>
                  <span className="text-sm font-regular text-center text-gray-600 ml-1">
                    {globalVariables.dragAndDrop}{" "}
                    {isFileUpload ? fileUploadDesc : globalVariables.svgPNG}
                  </span>
                </div>
              </div>
            </div>
          </label>
        )}

        {error && (
          <span className="text-red font-medium max-w-[352px] text-sm mt-1 self-start">
            {error}
          </span>
        )}
      </div>

      {isFileUpload && !!fileName && (
        <div
          className={`bg-white rounded-xl border border-solid ${width} mt-5 p-4 ${"border-gray-300"} flex flex-row justify-between`}
          style={{ width }}
        >
          <div className="flex flex-row">
            <img src={file} alt="" />
            <div className="ml-2 flex flex-col">
              <span className="text-sm font-medium text-gray-700">
                {fileName}
              </span>
              <span className="text-sm font-normal text-gray-600">
                {`${fileSize} KB`}
              </span>
            </div>
          </div>
          {!loading && (
            <button onClick={removeFile}>
              <img src={trash} alt="" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
